import React from 'react';

// Renders the explanatory pages from their route definition. The same body,
// sections and FAQ are written into the page's HTML at build time by
// scripts/prerender.js, so what a crawler reads and what a visitor sees after
// React mounts come from one source and cannot drift.

type Section = {
  h2: string;
  paras?: string[];
  list?: string[];
};

type FaqEntry = { q: string; a: string };

export type ReferenceRoute = {
  body?: string[];
  sections?: Section[];
  faq?: FaqEntry[];
};

const Reference: React.FC<{ route: ReferenceRoute }> = ({ route }) => (
  <article className="prose prose-slate max-w-3xl">
    {route.body?.map((para, i) => (
      <p key={`body-${i}`} className="text-slate-700 leading-relaxed mb-4">
        {para}
      </p>
    ))}

    {route.sections?.map((section) => (
      <section key={section.h2} className="mt-10">
        <h2 className="text-xl font-bold text-slate-900 mb-3">{section.h2}</h2>
        {section.paras?.map((para, i) => (
          <p key={i} className="text-slate-700 leading-relaxed mb-4">
            {para}
          </p>
        ))}
        {section.list?.length ? (
          <ul className="list-disc pl-6 space-y-2 text-slate-700">
            {section.list.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        ) : null}
      </section>
    ))}

    {route.faq?.length ? (
      <section className="mt-12">
        <h2 className="text-xl font-bold text-slate-900 mb-4">Frequently asked questions</h2>
        <div className="space-y-6">
          {route.faq.map((entry) => (
            <div key={entry.q}>
              <h3 className="font-semibold text-slate-900">{entry.q}</h3>
              <p className="mt-1 text-slate-700 leading-relaxed">{entry.a}</p>
            </div>
          ))}
        </div>
      </section>
    ) : null}
  </article>
);

export default Reference;
